import { useCallback, useEffect, useMemo, useState } from "react";
import {
  DropdownInput,
  FlexContainers,
  Modal,
  SmallButton,
  WrapperContainer
} from "../../components";
import { strCode } from "../../consts";
import { t } from "../../services";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const DuplicateDestinationModal = ({ active, setActive, onSubmit, apps }) => {
  const markets = useSelector((state) => state.markets?.markets);

  const [appOptions, setAppOptions] = useState([]);
  const [marketOptions, setMarketOptions] = useState([]);

  const [app, setApp] = useState();
  const [market, setMarket] = useState();

  const valid = useMemo(() => app && market, [app, market]);

  const resetForm = () => {
    setApp(null);
    setMarket(null);
  };

  const handleSubmit = useCallback(async () => {
    if (!valid) return;

    await onSubmit(app, market);
    resetForm();
  }, [app, market, onSubmit]);

  const handleClose = useCallback(async () => {
    setActive(false);
    resetForm();
  }, [setActive]);

  useEffect(() => {
    const options = Array.from(apps).map((app) => {
      return { id: app.appType, value: app.name };
    });

    setAppOptions(options);

    if (!options.some((option) => option.id === app)) {
      setApp(null);
    }
  }, [apps]);

  useEffect(() => {
    const options = Array.from(markets)
      .filter((market) => market.activeAppTypes.includes(app))
      .map((market) => {
        return { id: market.id, value: market.name };
      });

    setMarketOptions(options);

    if (!options.some((option) => option.id === market)) {
      setMarket(null);
    }
  }, [app]);

  return (
    <Modal
      active={active}
      closable={false}
      title={t(strCode.DUPLICATE_TO_ANOTHER_LOCATION)}
      modalFooter={
        <WrapperContainer
          Container={FlexContainers.FlexRowEnd}
          gap={8}
          width={"100%"}
          height={"100%"}>
          <SmallButton secondary onClick={handleClose}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <SmallButton disabled={!valid} onClick={handleSubmit}>
            {t(strCode.PROCEED_BTN)}
          </SmallButton>
        </WrapperContainer>
      }>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={16} minWidth={510}>
        <DropdownInput
          options={appOptions}
          selectedOption={appOptions.find((x) => x.id === app)}
          title={t(strCode.APPLICATION_TITLE)}
          onSelectOption={setApp}
          placeholder={t(strCode.SELECT_PLACEHOLDER_2)}
        />
        <DropdownInput
          options={marketOptions}
          selectedOption={marketOptions.find((x) => x.id === market)}
          title={t(strCode.MARKET_TITLE)}
          disabled={!app}
          onSelectOption={setMarket}
          placeholder={t(strCode.SELECT_PLACEHOLDER_2)}
        />
      </WrapperContainer>
    </Modal>
  );
};

DuplicateDestinationModal.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  apps: PropTypes.array.isRequired
};

export default DuplicateDestinationModal;
